export type Filtering = {
  query?: string;
  date?: { from?: string; to?: string };
  responseType?: string;
};

function useFilters() {
  const getFilters = (filtering?: Filtering) => {
    let filterStr = "";
    if (filtering?.query) {
      filterStr += `&query=${filtering.query}`;
    }

    if (filtering?.date?.from) {
      filterStr += `&since=${filtering.date.from}`;
    }

    if (filtering?.date?.to) {
      filterStr += `&until=${filtering.date.to}`;
    }

    if (filtering?.responseType) {
      if (filtering.responseType === "all") {
        filterStr += ``;
      } else filterStr += `&response_types=${filtering.responseType}`;
    }

    return filterStr ? `${filterStr.slice(1)}` : "";
  };

  return { getFilters };
}

export default useFilters;
